import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { MessageService } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../services/api.service';
import { init } from '../editorconfig';
import { UploadService } from '../../services/upload/upload.service';

@Component({
  selector: 'app-upload-challenges',
  standalone: false,
  templateUrl: './upload-challenges.component.html',
  styleUrl: './upload-challenges.component.scss',
})
export class UploadChallengesComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @Output() generatePDFEmitter: EventEmitter<any> = new EventEmitter();
  @Output() stepCompleted = new EventEmitter<void>();
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  @Input() schemeType: string;
  @Input() screening: string = '';
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  challengeForm: FormGroup;
  proposalForm: FormGroup;
  uploadedFiles: any[] = [];
  apiUrl = environment.APIUrl;
  payload: any;
  @Input() id: any;
  PDSGenId: any;
  needGenData: any;
  needGenId;
  draftSotr: File;
  draftSotrFile: File | null = null;
  supportingDocsFiles: File | null = null;
  private subscriptions = new Subscription();
  @ViewChild('draftSotrUpload') draftSotrUpload!: FileUpload;
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  userID: any;
  categoryOptions = [
    { label: 'To Move', value: 'To Move' },
    { label: 'To Fight', value: 'To Fight' },
    { label: 'To Float', value: 'To Float' },
  ];
  userList: any;
  userListCopy: any[];
  allDmsFiles: any[]=[];
  unitList: any;
  isChallengeFormOpen: boolean = true; // Open by default in process flow
  constructor(
    private messageService: MessageService,
    private uploadService: UploadService,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private fb: FormBuilder
  ) {
    const role = sessionStorage.getItem('user_role_id');
    this.userID = role;
  }
  ngOnInit(): void {
    this.challengeForm = this.fb.group({
      organisation: ['', Validators.required],
      category: [''],
      releaseDate: ['', Validators.required],
      approvedBy: [''],
      coordinatingAgency: ['', Validators.required],
      technologyDomain: ['', Validators.required],

      challengeTitle: ['', Validators.required],
      nodalOfficer: [null, Validators.required],
      firmName: ['', Validators.required], // ✅ New field
      recommendationPI: ['', Validators.required],
      problemStatement: ['', Validators.required],
      challengeBrief: ['', Validators.required],
      prototypeDevelopment: ['', Validators.required],
      requirement: ['', Validators.required],
      // ipValue: [''],
      functionalAdvantages: ['', Validators.required],
      domestic: ['', Validators.required],
      substitution: ['', Validators.required],
      preliminaryScope: ['', Validators.required],
      competitiveSolution: ['', Validators.required],
      potentialMarket: ['', Validators.required],
      riskAssessment: ['', Validators.required],
      mpoQty: ['', Validators.required],
    });

    this.proposalForm = this.fb.group({
      technologyInsertion: [''],
      justificationText: [''],
      exportPotential: [''],
      objective: [''],
      existingSystem: [''],
      functionalRequirements: [''],
      contemporarySolutions: [''],
      miscellaneousInfo: [''],
      references: [''],
      keywords: [''],
      estimatedRequirement: [''],
      testingMethodology: [''],
      civilSpinOffs: [''],
      technologyReadinessLevel: [''],
      proposalExplanation: [''],
      qaAgency: [''],
      apsoConcurrence: [''],
      psqr: [''],
      additionalInformation: [''],
      qtyRequired: [''],
    });

    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      const proposalName = params['name'];
      this.payload = {
        proposal_id: proposalId,
        proposal_name: proposalName,
      };
    });
    if (this.schemeType == 'tdf') {
      this.getTDFData();
    } else {
      this.getChallenge();
      this.getUserList();
      this.getUnit()
    }
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  ngAfterViewInit() {
    setTimeout(() => {
      if (this.isEditable) {
        this.isEditorDisabled = false;
        this.challengeForm?.enable();
        this.proposalForm?.enable();
      } else {
        this.isEditorDisabled = true;
        this.challengeForm?.disable();
        this.proposalForm?.disable();
      }
      //  this.rebuildEditor();
    }, 3000);
  }
  editorReady = false;
  rebuildEditor() {
    this.editorReady = false; // destroy
    setTimeout(() => {
      this.init = this.getTinyInit(); // refresh config
      this.editorReady = true; // recreate editor
    }, 0);
  }
  getTinyInit(): EditorComponent['init'] {
    return {
      plugins:
        'advlist anchor fullscreen insertdatetime autolink link lists image code advcode mergetags wordcount ai a11ychecker advcode advtemplate advlist advtable anchor autocorrect autosave editimage image link linkchecker lists markdown media mediaembed pageembed powerpaste searchreplace table template tinymcespellchecker typography visualblocks wordcount',
      toolbar:
        'undo redo fullscreen | styles fontsizeinput lineheight |insertdatetime  bold italic strikethrough backcolor forecolor visualblocks | align bullist numlist outdent indent | advlist  table link image media pageembed | spellcheckdialog a11ycheck code | searchreplace',
      readonly: this.isEditorDisabled,
    };
  }
  goToNextStep() {
    this.stepCompleted.emit();
  }

  toggleChallengeForm() {
    this.isChallengeFormOpen = !this.isChallengeFormOpen;
  }

  getChallengeUrl(): string {
    if (this.screening === 'formulation') {
      return `/idex/challenges/?proposal_step=${this.id}&proposal_step__proposal=${this.payload.proposal_id}`;
    } else if (this.screening === 'initiation') {
      return `/idex/screening/challenge/?proposal_step=${this.id}&proposal_step__proposal=${this.payload.proposal_id}`;
    } else {
      return `/idex/challenge/approval/?proposal_step=${this.id}&proposal_step__proposal=${this.payload.proposal_id}`;
    }
  }

  onFileSelect(event: any, type: string) {
    const files: File[] = event.files;

    if (type === 'draftSotr') {
      this.draftSotrFile = files[0]; // Only one file expected
    } else if (type === 'supportingDocs') {
      // this.supportingDocsFiles = [...this.supportingDocsFiles, ...files];
      this.supportingDocsFiles = files[0];
    }
  }

  onUploadDraftSotr(event: any) {
    const file: File = event.files[0];
    if (file) {
      this.draftSotrFile = file;
      this.messageService.add({
        severity: 'success',
        summary: 'File attached successfully',
        detail: file.name,
      });
    }
  }

  onUploadSupportingDocs(event: any) {
    // const files: File[] = event.files;
    const file: File = event.files[0];
    if (file) {
      this.supportingDocsFiles = file;
    }
    // this.supportingDocsFiles = [...this.supportingDocsFiles, ...files];
    this.messageService.add({
      severity: 'success',
      summary: 'Supporting Documents Uploaded',
      detail: ` files uploaded`,
    });
  }
  getFileName(url: string): string {
    const fileName = url.split('/').pop() || 'Unknown File';
    return fileName.length > 50 ? fileName.substring(0, 50) + '...' : fileName;
  }
  generatePDF() {
    let payload;
    if (this.schemeType == 'tdf') {
      payload = {
        url: '/revenue/need/version-control/',
        data: [
          { key: 'Proposal Name', value: this.payload?.proposal_name },
          {
            key: 'Title of the Requirement',
            value: this.proposalForm.get('technologyInsertion')?.value,
          },
          {
            key: 'Description of major system/sub-system and usage',
            value: this.proposalForm.get('justificationText')?.value,
          },
          {
            key: 'Reason for pursuing under TDF scheme',
            value: this.proposalForm.get('exportPotential')?.value,
          },
          {
            key: 'Technology Area (Discipline, Sub-discipline)',
            value: this.proposalForm.get('stakeholderDiscussions')?.value,
          },
          {
            key: 'Objective (Product/System/Item)',
            value: this.proposalForm.get('objective')?.value,
          },
          {
            key: 'Existing System Description & Use',
            value: this.proposalForm.get('existingSystem')?.value,
          },
          {
            key: 'Functional & Operational Requirements',
            value: this.proposalForm.get('functionalRequirements')?.value,
          },
          {
            key: 'Contemporary Solutions (National/International)',
            value: this.proposalForm.get('contemporarySolutions')?.value,
          },
          {
            key: 'Miscellaneous Information',
            value: this.proposalForm.get('miscellaneousInfo')?.value,
          },
          {
            key: 'References',
            value: this.proposalForm.get('references')?.value,
          },
          { key: 'Keywords', value: this.proposalForm.get('keywords')?.value },
          {
            key: 'Estimated Navy Requirement (3-5 yrs)',
            value: this.proposalForm.get('estimatedRequirement')?.value,
          },
          {
            key: 'Testing Methodology, Criteria, Venue',
            value: this.proposalForm.get('testingMethodology')?.value,
          },
          {
            key: 'Likely Civil Spin Offs',
            value: this.proposalForm.get('civilSpinOffs')?.value,
          },
          {
            key: 'Technology Readiness Level (TRL)',
            value: this.proposalForm.get('technologyReadinessLevel')?.value,
          },
          {
            key: 'Proposal Category (Substitution/Upgrade/etc.)',
            value: this.proposalForm.get('proposalExplanation')?.value,
          },
          { key: 'QA Agency', value: this.proposalForm.get('qaAgency')?.value },
          {
            key: 'Concurrence by APSO',
            value: this.proposalForm.get('apsoConcurrence')?.value,
          },
          {
            key: 'PSQR',
            value: this.proposalForm.get('psqr')?.value,
          },
          {
            key: 'Additional Information',
            value: this.proposalForm.get('additionalInformation')?.value,
          },
          {
            key: 'Quantity Required',
            value: this.proposalForm.get('qtyRequired')?.value,
          },
        ],
      };
    } else {
     payload = {
        url: '/revenue/need/version-control/',
        data: [
          { key: 'Proposal Name', value: this.payload.proposal_name },
          {
            key: 'Organisation',
            value: this.challengeForm.get('organisation')?.value,
          },
          { key: 'Category', value: this.challengeForm.get('category')?.value },
          {
            key: 'Release Date',
            value: this.challengeForm.get('releaseDate')?.value,
          },
          {
            key: 'Approved By',
            value: this.challengeForm.get('approvedBy')?.value,
          },
          {
            key: 'Coordinating Agency',
            value: this.challengeForm.get('coordinatingAgency')?.value,
          },
          {
            key: 'Technology Domain',
            value: this.challengeForm.get('technologyDomain')?.value,
          },

          {
            key: 'Challenge Title',
            value: this.challengeForm.get('challengeTitle')?.value,
          },
          {
            key: 'Problem Statement',
            value: this.challengeForm.get('problemStatement')?.value,
          },
          {
            key: 'Challenge Brief/ Definition',
            value: this.challengeForm.get('challengeBrief')?.value,
          },
          {
            key: 'Firm Name',
            value: this.challengeForm.get('firmName')?.value,
          },
          {
            key: 'Recommendation of PI',
            value: this.challengeForm.get('recommendationPI')?.value,
          },
          {
            key: 'Future Expectation from the prototype development',
            value: this.challengeForm.get('prototypeDevelopment')?.value,
          },
          {
            key: 'Need/Requirement of the proposed challenge',
            value: this.challengeForm.get('requirement')?.value,
          },
          // {
          //   key: 'IP Value',
          //   value: this.challengeForm.get('developmentPlatforms')?.value,
          // },
          {
            key: 'Functional Advantages',
            value: this.challengeForm.get('functionalAdvantages')?.value,
          },
          {
            key: 'Domestic Capability Development',
            value: this.challengeForm.get('domestic')?.value,
          },
          {
            key: 'Import Substitution (Reliability and Flexibility of existing source of import)',
            value: this.challengeForm.get('substitution')?.value,
          },
          {
            key: 'Preliminary scope of solution being developed)',
            value: this.challengeForm.get('preliminaryScope')?.value,
          },
          {
            key: 'Global competitive nature of the problem including novelty of the solution (from user prospective)',
            value: this.challengeForm.get('competitiveSolution')?.value,
          },
          {
            key: 'Potential Market for product/technology (from user perspective)',
            value: this.challengeForm.get('potentialMarket')?.value,
          },
          {
            key: 'Risk Assessment',
            value: this.challengeForm.get('riskAssessment')?.value,
          },
          {
            key: 'Pilot Procurement Plan with Minimum Pilot Order Quantity(MPQ)',
            value: this.challengeForm.get('mpoQty')?.value,
          },
        ],
      };
    }

    this.generatePDFEmitter.emit(payload);
  }
  onSubmit() {
    if (this.schemeType == 'tdf') {
      const formData = new FormData();
      formData.append('proposal_step', this.id);
      formData.append('title', this.proposalForm.value.technologyInsertion);
      formData.append(
        'major_description',
        this.proposalForm.value.justificationText
      );
      formData.append(
        'technology_area',
        this.proposalForm.value.exportPotential
      );
      formData.append('objective', this.proposalForm.value.objective);
      formData.append('description', this.proposalForm.value.existingSystem);
      formData.append(
        'functional_requirement',
        this.proposalForm.value.functionalRequirements
      );
      formData.append(
        'contemporary_solution',
        this.proposalForm.value.contemporarySolutions
      );
      formData.append(
        'miscellaneous_information',
        this.proposalForm.value.miscellaneousInfo
      );
      formData.append('references', this.proposalForm.value.references);
      formData.append('keywords', this.proposalForm.value.keywords);
      formData.append(
        'estimated_requirement',
        this.proposalForm.value.estimatedRequirement
      );
      formData.append(
        'testing_methodology',
        this.proposalForm.value.testingMethodology
      );
      formData.append('civil_spin', this.proposalForm.value.civilSpinOffs);
      formData.append(
        'technology_readiness',
        this.proposalForm.value.technologyReadinessLevel
      );
      formData.append(
        'proposal_explain',
        this.proposalForm.value.proposalExplanation
      );
      formData.append('qa_agency', this.proposalForm.value.qaAgency);
      formData.append('concurrence', this.proposalForm.value.apsoConcurrence);
      formData.append('psqr', this.proposalForm.value.psqr);
      formData.append(
        'additional_information',
        this.proposalForm.value.additionalInformation
      );
      formData.append('quantity_required', this.proposalForm.value.qtyRequired);

      if (this.draftSotrFile) {
        formData.append('upload_photograph', this.draftSotrFile);
      }

      if (this.supportingDocsFiles) {
        // this.supportingDocsFiles.forEach(file => {
        formData.append('feasibility_study', this.supportingDocsFiles); // Change key name if needed
        // });
      }

      if (this.needGenId) {
        const sub = this.apiService
          .putAPI('/tdf/need-generation/' + this.needGenId + '/', formData)
          .subscribe((res: any) => {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Form submitted successfully',
            });
            this.fileUpload.clear();
            this.draftSotrUpload.clear();
            this.getTDFData();
          });
        this.subscriptions.add(sub);
      } else {
        const sub = this.apiService
          .postAPI('/tdf/need-generation/', formData)
          .subscribe({
            next: (response: any) => {
              this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: 'Form submitted successfully',
              });
              this.fileUpload.clear();
              this.draftSotrUpload.clear();
              this.getTDFData();
            },
          });
        this.subscriptions.add(sub);
      }
    } else {
      let formData: FormData = new FormData();
      if (this.screening == 'formulation') {
        formData.append('proposal_step', this.id);
      }

      formData.append(
        'organisation',
        this.challengeForm.get('organisation').value
      );
      formData.append('category', this.challengeForm.get('category').value);
       formData.append('name_firm', this.challengeForm.value.firmName);
      formData.append('recommendation_pi', this.challengeForm.value.recommendationPI);
      formData.append(
        'release_date',
        this.challengeForm.get('releaseDate').value
      );
      if (this.challengeForm.get('approvedBy').value != null) {
        formData.append(
          'approved_by',
          this.challengeForm.get('approvedBy').value
        );
      }
      formData.append(
        'coordinated_agency',
        this.challengeForm.get('coordinatingAgency').value
      );
      formData.append(
        'technology_domain',
        this.challengeForm.get('technologyDomain').value
      );

      formData.append('title', this.challengeForm.get('challengeTitle').value);
      formData.append(
        'nodal_officer',
        this.challengeForm.get('nodalOfficer').value
      );
      formData.append(
        'problem_statement',
        this.challengeForm.get('problemStatement').value
      );
      formData.append(
        'challenge_brief',
        this.challengeForm.get('challengeBrief').value
      );
      formData.append(
        'prototype_development',
        this.challengeForm.get('prototypeDevelopment').value
      );
      formData.append(
        'requirement',
        this.challengeForm.get('requirement').value
      );
      // formData.append('ip_value', this.challengeForm.get('ipValue').value);
      formData.append(
        'functional_advantages',
        this.challengeForm.get('functionalAdvantages').value
      );
      formData.append('domestic', this.challengeForm.get('domestic').value);
      formData.append(
        'substitution',
        this.challengeForm.get('substitution').value
      );
      formData.append(
        'preliminary_scope',
        this.challengeForm.get('preliminaryScope').value
      );
      formData.append(
        'competitive_solution',
        this.challengeForm.get('competitiveSolution').value
      );
      formData.append(
        'potential_market',
        this.challengeForm.get('potentialMarket').value
      );
      formData.append(
        'risk_assessment',
        this.challengeForm.get('riskAssessment').value
      );
      formData.append('mpo_qty', this.challengeForm.get('mpoQty').value);

      if (this.draftSotrFile) {
        formData.append('pds', this.draftSotrFile);
      }

      if (this.supportingDocsFiles) {
        // this.supportingDocsFiles.forEach(file => {
        formData.append('pru', this.supportingDocsFiles); // Change key name if needed
        // });
      }

      if (this.PDSGenId) {
        //  let url = this.screening ?  `/idex/screening/challenge/${this.PDSGenId}/`  :  `/idex/challenges/${this.PDSGenId}/`
        let url;
        if (this.screening == 'formulation') {
          url = `/idex/challenges/${this.PDSGenId}/`;
        } else if (this.screening == 'initiation') {
          url = `/idex/screening/challenge/${this.PDSGenId}/`;
        } else {
          url = `/idex/challenge/approval/${this.PDSGenId}/`;
        }

        const sub = this.apiService.putAPI(url, formData).subscribe({
          next: (res: any) => {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: res.message || 'Challenge updated successfully.',
            });
            this.fileUpload.clear();
            this.draftSotrUpload.clear();
            this.getChallenge();
          },
          error: (err) => {},
        });
        this.subscriptions.add(sub);
      } else {
        //  let url = this.screening ?  `/idex/screening/challenge/` :  `/idex/challenges/`
        let url;
        if (this.screening == 'formulation') {
          url = `/idex/challenges/`;
        } else if (this.screening == 'initiation') {
          url = `/idex/screening/challenge/`;
        } else {
          url = `/idex/challenge/approval/`;
        }
        const sub = this.apiService.postAPI(url, formData).subscribe({
          next: (res: any) => {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: res.message || 'Challenge added successfully.',
            });
             this.fileUpload.clear();
            this.draftSotrUpload.clear();
            this.getChallenge();
          },
          error: (err) => {},
        });
        this.subscriptions.add(sub);
      }
    }
  }

  getChallenge() {
    // let url = this.screening ?  `/idex/screening/challenge/?proposal_step=${this.id}&proposal_step__proposal=${this.payload.proposal_id}` : `/idex/challenges/?proposal_step=${this.id}&proposal_step__proposal=${this.payload.proposal_id}`
    let url;
    if (this.screening == 'formulation') {
      url = `/idex/challenges/?proposal_step=${this.id}&proposal_step__proposal=${this.payload.proposal_id}`;
    } else if (this.screening == 'initiation') {
      url = `/idex/screening/challenge/?proposal_step=${this.id}&proposal_step__proposal=${this.payload.proposal_id}`;
    } else {
      url = `/idex/challenge/approval/?proposal_step=${this.id}&proposal_step__proposal=${this.payload.proposal_id}`;
    }
    const sub = this.apiService.getAPI(url).subscribe((resp: any) => {
      let res = resp[0] || resp.challenge;
      this.needGenData = resp[0] || resp.challenge;
      // Open challenge form section when data is loaded
      if (this.needGenData) {
        this.isChallengeFormOpen = true;
      }
      this.challengeForm.patchValue({
        organisation: res?.organisation,
        category: res.category,
        releaseDate: res.release_date,
        approvedBy: res.approved_by,
        coordinatingAgency: res.coordinated_agency,
        technologyDomain: res.technology_domain,

        challengeTitle: res.title,
        nodalOfficer: res.nodal_officer,
        problemStatement: res.problem_statement,
        challengeBrief: res.challenge_brief,
        firmName: res.name_firm,
        recommendationPI: res.recommendation_pi,
        prototypeDevelopment: res.prototype_development,
        requirement: res.requirement,
        // ipValue: res.ip_value,
        functionalAdvantages: res.functional_advantages,
        domestic: res.domestic,
        substitution: res.substitution,
        preliminaryScope: res.preliminary_scope,
        competitiveSolution: res.competitive_solution,
        potentialMarket: res.potential_market,
        riskAssessment: res.risk_assessment,
        mpoQty: res.mpo_qty,
      });
      if (res.status) {
        this.PDSGenId = res?.id;
      }
    });
    this.subscriptions.add(sub);
  }
  // this is use for upload document table
  onDocumentUpload(data:any){
    console.log('>>>>data from upload', data);
    const formData = new FormData();
    formData.append('proposal_step',this.id);
    formData.append('name', data.name);
    formData.append('description', data.description);
    formData.append('file', data.file);

    // ✅ Use your service method here
    this.uploadService.uploadneedGenData(formData).subscribe({
      next:(res:any)=>{
        console.log('>>>>>>res need upload data',res);
        // ✅ Reset the form inside the child component
        // this.uploadDocumentComp.uploadForm.reset();
        // console.log('🧹 Form reset successfully after upload');
      },
      // next: (event: HttpEvent<any>) => {
      //   if (event.type === HttpEventType.UploadProgress && event.total) {
      //     this.uploadProgress = Math.round((event.loaded / event.total) * 100);
      //   } else if (event.type === HttpEventType.Response) {
      //     console.log('✅ Upload successful:', event.body);
      //     this.uploadProgress = 0;
      //   }
      // },
      error: (err) => {
        console.error('❌ Upload failed:', err);
      }
    });    
  }

  onDocumentEdited(updatedDoc: any) {
    console.log('✏️ Edited document from child:', updatedDoc);
    const formData = new FormData();
    formData.append('proposal_step', this.id);
    formData.append('name', updatedDoc.name);
    formData.append('description', updatedDoc.description);
    // Only append file if it's a new file (File object)
    if (updatedDoc.file instanceof File) {
      formData.append('file', updatedDoc.file);
    }
    // ✅ Update API call
    this.uploadService.updateUploadNeedGenData(updatedDoc.id, formData).subscribe({
      next: (response: any) => {
        console.log('✅ Document updated successfully:', response);
        // ✅ Replace the updated record instead of pushing new
        const index = this.allDmsFiles.findIndex((d) => d.id === updatedDoc.id);
        if (index !== -1) {
          // Update the existing record
          this.allDmsFiles[index] = { ...this.allDmsFiles[index], ...updatedDoc };
        }
      },
      error: (err) => {
        console.error('❌ Update failed:', err);
      },
    });
  }

  onDocumentDeleted(docId: number) {
    console.log('🗑️ Deleted document ID from child:', docId);
    this.uploadService.deleteUploadNeedGenData(docId).subscribe({
      next: (res:any)=>{
          console.log('delete uploadData',res);
      },
      error: (err) => {
          console.error('❌ Upload failed:', err);
        }
    })
    // Optionally call delete API
  }

  getTDFData() {
    const sub = this.apiService
      .getAPI(
        `/tdf/need-generation/?proposal_step=${this.id}&proposal_step__proposal=${this.payload.proposal_id}`
      )
      .subscribe((res: any) => {
        this.needGenData = res[0];
        this.proposalForm.patchValue({
          technologyInsertion: this.needGenData.title,
          justificationText: this.needGenData.major_description,
          exportPotential: this.needGenData.technology_area,
          objective: this.needGenData.objective,
          existingSystem: this.needGenData.description,
          functionalRequirements: this.needGenData.functional_requirement,
          contemporarySolutions: this.needGenData.contemporary_solution,
          miscellaneousInfo: this.needGenData.miscellaneous_information,
          references: this.needGenData.references,
          keywords: this.needGenData.keywords,
          estimatedRequirement: this.needGenData.estimated_requirement,
          testingMethodology: this.needGenData.testing_methodology,
          civilSpinOffs: this.needGenData.civil_spin,
          technologyReadinessLevel: this.needGenData.technology_readiness,
          proposalExplanation: this.needGenData.proposal_explain,
          qaAgency: this.needGenData.qa_agency,
          apsoConcurrence: this.needGenData.concurrence,
          psqr: this.needGenData.psqr,
          additionalInformation: this.needGenData.additional_information,
          qtyRequired: this.needGenData.quantity_required,
        });
        if (res[0]) {
          this.needGenId = res[0]?.id;
        }
        sessionStorage.setItem('needStepID', this.id);
      });
    this.subscriptions.add(sub);
  }
  getUserList() {
    const sub = this.apiService
      .getAPI('/account/users/')
      .subscribe((res: any) => {
        this.userList = res.data;
        this.userListCopy = [...this.userList];
      });
    this.subscriptions.add(sub);
  }
   onUserChange(event: any) {
    this.userID = event.value;
  }
  onUnitChange(event: any) {
    let unit_id = event.value
    this.userList = this.userListCopy.filter(user => user.unit?.id == unit_id);
  }
    getUnit() {
    const sub = this.apiService.getAPI('/master/units/').subscribe((res: any) => {
      this.unitList = res.data;
    })
    this.subscriptions.add(sub);
  }
}
